const useCard = () => {
  const getDestinationsString = (destinations = []) => {
    if (!!destinations && destinations.length > 0) {
      return destinations.reduce((total, { slug, display }, index) => {
        return (
          total + ` ${display} ${index + 1 < destinations.length ? '/ ' : ''}`
        );
      }, '');
    } else return null;
  };

  return { getDestinationsString };
};

export default useCard;
